import { skills } from "../../utils";

const Skills = () => {
  return (
    <div className="skills_container">
      <h2 className="fs-4">TECH STACK</h2>
      <div className="skills_stack">
        {skills.map((skill, index) => (
          <div className="skills_div" key={index}>
            {skill.icon}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
